<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="query.orderNum" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="订单来源：">
            <el-select v-model="query.orderSource" placeholder="请选择" clearable size="small">
              <el-option label="APP" value="APP"></el-option>
              <el-option label="后台" value="PC"></el-option>
            </el-select>
          </el-form-item>
        
          <el-form-item label="是否直播订单：">
            <el-select v-model="query.isLiveOrder" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否直播福袋订单：">
            <el-select v-model="query.isLiveBlessingBag" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否充值礼包订单：">
            <el-select v-model="query.isRechargeGift" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单类型：">
            <el-select v-model="query.type" placeholder="请选择" size="small" @change="changeOrderType">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="订货订单" :value="1"></el-option>
              <el-option label="秒杀订单" :value="3"></el-option>
            </el-select>
          </el-form-item>
       
          <el-form-item label="快递类型：">
            <el-select v-model="query.deliveryOptionsId" placeholder="请选择" clearable size="small">
              <el-option v-for="(it,idx) in deliveryAllList" :key="idx" :label="it.name" :value="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号：">
            <el-input v-model="query.logisticsNumber" placeholder="请输入快递单号" clearable size="small" />
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="query.allGoodsName" placeholder="请输入商品名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="支付方式：">
            <el-select v-model="query.orderPayType" placeholder="请选择" clearable size="small">
              <el-option label="零售价支付" :value="1"></el-option>
              <el-option label="余额账户支付" :value="2"></el-option>
              <el-option label="赠送账户支付" :value="4"></el-option>
              <el-option label="在线支付" :value="5"></el-option>
              <el-option label="组合支付" :value="6"></el-option>
            </el-select>
          </el-form-item>
          <!-- REQ-2026-826259 商城活动规则筛选项 -->
          <el-form-item label="是否是活动商品：">
            <el-select v-model="query.isActivityGoods" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否只支持现金购买：">
            <el-select v-model="query.isCashOnlyGoods" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动支付模式：">
            <el-select v-model="query.activityPayMode" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="现金" value="CASH"></el-option>
              <el-option label="余额" value="BALANCE"></el-option>
              <el-option label="小杜币" value="XIAODUBI"></el-option>
              <el-option label="学费赠送" value="GIFT"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model="query.name" placeholder="请输入下单人/收件人姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.phone" placeholder="请输入下单人/收件人手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="是否包邮：">
            <el-select v-model="query.noFreight" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="包裹数量：">
            <el-input v-model="query.parcelNum" placeholder="请输入包裹数量" clearable size="small" />
          </el-form-item>
          <el-form-item label="随货同行单：">
            <el-input v-model="query.customerIdcard" placeholder="请输入随货同行单抬头" clearable size="small" />
          </el-form-item>
          <el-form-item label="时间区域：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <!-- <el-option label="支付时间" :value="1"></el-option> -->
              <el-option label="下单时间" :value="2"></el-option>
              <el-option label="发货时间" :value="3"></el-option>
              <el-option label="完成时间" :value="4"></el-option>
              <el-option label="取消时间" :value="5"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-box" style="text-align: right;">
        <!-- <el-button type="primary" size="mini" @click="addOrderToYongYou" plain v-hasPermi="['order:goodsorder:push']">补推订单</el-button> -->
        <el-button type="primary" size="mini" @click="handleExport" plain v-hasPermi="['order:goodsorder:export']">导出</el-button>
        <el-button type="primary" @click="handleAdd" size="mini" icon="el-icon-plus" v-hasPermi="['order:goodsorder:add']">添加订货订单</el-button>
        <el-button type="primary" @click="handleSeckillAdd" size="mini" icon="el-icon-plus" v-hasPermi="['order:goodsorder:add']">添加秒杀订单</el-button>
        <el-button type="danger" size="mini" @click="handleBatchWriteoff" v-if="+activeName === 6 || +activeName === 3" plain>批量核销订单</el-button>
        <el-button type="danger" size="mini" @click="handlechangeReceiptMailingBatch" v-if="+activeName === 6 || +activeName === 3" plain>批量变更发货订单</el-button>
        <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields">
      </div>
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="exchangeTotal">
          <el-tab-pane :label="'待发货('+ exchangeTotal.deliverNum +')'" name="2"></el-tab-pane>
          <el-tab-pane :label="'待收货('+ exchangeTotal.shippedNum +')'" name="3"></el-tab-pane>
          <el-tab-pane :label="'待自提('+ exchangeTotal.selfPickupNum +')'" name="6"></el-tab-pane>
          <el-tab-pane :label="'已完成('+ exchangeTotal.accomplishNum +')'" name="4"></el-tab-pane>
          <el-tab-pane :label="'待付款('+ exchangeTotal.unpaidNum +')'" name="1"></el-tab-pane>
          <el-tab-pane :label="'已取消('+ exchangeTotal.cancelNum +')'" name="0"></el-tab-pane>
          <el-tab-pane :label="'已失效('+ exchangeTotal.loseEfficacyNum +')'" name="-1"></el-tab-pane>
        </el-tabs>
      </div>
      <el-table ref="table" v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" fit :key="activeName">
        <el-table-column type="selection" width="50" key="selection" />
        <el-table-column :min-width="item.width" v-for="(item,index) in dynamicHeaders" :key="item.prop" :prop="item.prop" :label="item.label" :fixed="item.prop === 'orderNum'" :sortable="item.isSortable" :show-overflow-tooltip="item.showToolTip">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)" v-if="item.prop === 'orderNum'">{{row.orderNum}}</el-link>
            <span v-else-if="item.prop === 'type'">{{row.type === 1?'订货订单':(row.type === 2?'积分订单':(row.type === 3?'秒杀订单':''))}}</span>
            <span v-else-if="item.prop === 'orderFlag'">{{orderFlagText(row)}}</span>
            <template v-else-if="item.prop === 'payTotalMoney'">
              <div class="tableDiv-txt">
                <span>原价:{{row.payTotalMoney}}</span>
                <span v-if='row.payDiscountMoney'>折扣优惠金额:{{row.payDiscountMoney}}
                  <span v-if='row.buyRatio'>({{ +row.buyRatio < 1? row.buyRatio*10:row.buyRatio }}折)</span> </span>
                <span v-if="row.orderPayType === 6">现金折扣:{{row.rmbBuyRatio}}</span>
              </div>
            </template>
            <template v-else-if="item.prop === 'goodsPayMoney'">
              <div class="tableDiv-txt">
                <span>商品支付金额:{{row.goodsPayMoney}}</span>
                <span>邮费支付金额:{{row.freight}}</span>
                <span>支付总金额:{{(row.allPayMoney + row.rmbMoney).toFixed(2) }}</span>
              </div>
            </template>
            <template v-else-if="item.prop === 'orderPayType'">
              {{row.orderPayType === 1?'零售价:':(row.orderPayType === 2?'余额:':(row.orderPayType === 3?'积分:':(row.orderPayType === 4?'赠送:':(row.orderPayType === 5?'在线:':'组合:'))))}}
              <template v-if='row.orderPayType != 5 && row.orderPayType != 6'> {{row.allPayMoney}}</template>
              <template v-if='row.orderPayType === 5'> {{row.rmbMoney}}</template>
              <template v-if='row.orderPayType === 6'>
                <div class="tableDiv-txt">
                  <span>{{row.goodsType === 1?'余额账户':(row.goodsType === 2?'零售价':(row.goodsType === 3?'学费':(row.goodsType === 4?'积分':'')))}}:{{row.allPayMoney}}</span>
                  <span>在线:{{row.rmbMoney}}</span>
                </div>
              </template>
            </template>
            <template v-else-if="item.prop === 'goodsActivityPOS'">
              <span v-for="(it,index) in row.goodsActivityPOS" :key="index">{{it.activityName}}<span v-if="index<row.goodsActivityPOS.length-1">、</span></span>
            </template>
            <template v-else-if="item.prop === 'custName'">
              <div class="tableDiv-txt">
                <span>姓名:{{row.custName}}</span>
                <span>手机号:{{row.custPho}}</span>
                <span>所属区域:{{row.custAddrProvinceCodeName}}{{row.custAddrCityCodeName}}{{row.custAddrAreaCodeName}}</span>
              </div>
            </template>
            <template v-else-if="item.prop === 'business'">
              <div class="tableDiv-txt">
                <span v-if="row.nameCustOne">总监:{{ row.nameCustOne }}</span>
                <span v-if="row.nameCustTwo">经理:{{ row.nameCustTwo }}</span>
                <span v-if="row.nameCustThree">大区:{{ row.nameCustThree }}</span>
                <span v-if="row.nameCustFour">地区:{{ row.nameCustFour }}</span>
                <span v-if="row.nameCustFive">县区:{{ row.nameCustFive}}</span>
              </div>
            </template>
            <template v-else-if="item.prop === 'technical'">
              <div class="tableDiv-txt">
                <span v-if="row.nameTechOne">总监:{{row.nameTechOne }}</span>
                <span v-if="row.nameTechTwo">督导:{{row.nameTechTwo}}</span>
                <span v-if="row.nameTechThree">技术老师:{{row.nameTechThree}}</span>
              </div>
            </template>
            <template v-else-if="item.prop === 'refundDetail'">
              <div class="tableDiv-txt" v-if="row.refundDetail && row.refundDetail.length > 0">
                <span v-for="(item,index) in row.refundDetail" :key="index">{{refundTypeTxt[item.moneyType]}}:{{item.money}}({{item.createdTime}})</span>
              </div>
            </template>
            <template v-else-if="item.prop === 'name'">
              <div class="tableDiv-txt">
                <span v-if="row.receiptType===10">姓名:{{row.name}}</span>
                <span v-if="row.receiptType===10">手机号:{{row.phone}}</span>
                <span v-if="row.receiptType===10">收货地址:{{row.addrProvince}}{{row.addrCity}}{{row.addrArea}}{{row.addrDetail}}</span>
                <span v-if="row.receiptType===20">自提地址:{{row.addrDetail}}</span>
              </div>
            </template>
            <!-- REQ-2026-826259 商城活动规则：活动支付模式、实际支付构成、命中规则、活动标签、赠送结果 -->
            <activity-summary v-else-if="['activityPayModeName','payCompositionText','activityTagList','rewardResultText'].includes(item.prop)" :row="row" :field="item.prop" />
            <span v-else-if="item.prop === 'deliveryOptionsName'">{{ row.receiptType === 10?row.deliveryOptionsName:"自提" }}</span>
            <span v-else-if="item.prop === 'state'">{{ orderStatus(row.state) }}</span>
            <span v-else-if="item.prop === 'killActPrice'">{{ row.type === 3?row.rmbMoney:'' }}</span>
            <span v-else-if="item.prop === 'operatedBy'">{{ row.operatedBy == -1?'':row.operatedBy }}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleUpOrder(row,1)" v-hasPermi="['order:goodsorder:copy']">复制订单</el-button>
            <el-button type="text" style="color: red" @click="handleUpOrder(row,6)" v-if="+activeName === 1 &&row.type === 1&& row.orderSource==='PC'" v-hasPermi="['order:goodsorder:pay']">支付</el-button>
            <el-button type="text" @click="handleUpOrder(row,2)" v-if="+activeName === 2||+activeName === 3&&row.receiptType===10" v-hasPermi="['order:goodsorder:waybill']">添加运单号</el-button>
            <el-button type="text" @click="handleUpOrder(row,3)" v-if="+activeName === 2&&row.receiptType===10" v-hasPermi="['order:goodsorder:push']">补推订单</el-button>
            <!-- 屏蔽取消订单按钮 -->
            <!-- <el-button type="text" @click="handleUpOrder(row,4)" v-if="+activeName === 1 || +activeName === 2 || +activeName === 3 || +activeName === 4" v-hasPermi="['order:goodsorder:cancel']">取消订单</el-button> -->
            <el-button type="text" @click="handleUpOrder(row,7)" v-if="+activeName === 2&&row.receiptType===10" v-hasPermi="['order:goodsorder:cancel']">取消订单(聚水潭)</el-button>
            <el-button type="text" @click="handleUpOrder(row,5)" v-if="row.orderSource=='PC'" v-hasPermi="['order:goodsorder:qrcode']">订单二维码</el-button>
            <el-button type="text" style="color: red" @click="handleUpOrder(row,8)" v-if="+activeName === 1 &&row.type === 3&& row.orderSource==='PC'" v-hasPermi="['order:goodsorder:pay']">支付秒杀订单</el-button>
            <el-button type="text" style="color: red" @click="handleUpOrder(row,9)" v-if="(+activeName === 6 || +activeName === 3) && row.receiptType === 20">核销订单</el-button>
            <el-button type="text" style="color: red" @click="handleUpOrder(row,10)" v-if="(+activeName === 6 || +activeName === 3) && row.receiptType === 20">变更发货订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 添加运单号 -->
    <el-dialog :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <el-form v-loading="fullscreenLoading" ref="form" :model="dialogQuery" label-width="100px" label-position="right" class="dialogDiv">
        <el-form-item label="快递公司">
          <el-select v-model="dialogQuery.deliveryOptionsId" placeholder="请选择" clearable size="small">
            <el-option v-for="(it,idx) in deliveryList" :key="idx" :label="it.name" :value="it.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加运单号">
          <el-input 
            v-model="dialogQuery.orderNum" 
            placeholder="请输入快递单号" 
            clearable 
            size="small"
            @input="validateOrderNum"
            :class="{ 'is-error': orderNumError }"
          />
          <div v-if="orderNumError" class="el-form-item__error">运单号只能包含数字和英文字母</div>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog" size="mini">取消</el-button>
          <el-button type="primary" @click="addLogisticsNumber" size="mini">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加订货订单 -->
    <order-add ref="orderAdd" @created="doQueryList({})" />
    <seckill-add-vue ref="seckillAdd" @created="doQueryList({})" />
    <!-- 订单二维码 -->
    <el-dialog :visible.sync="dialogImgCode" width="300px" :before-close="handleClose" v-if="dialogImgCode">
      <div v-if="qrCodeImg" class="img-box">
        <el-image style="width: 130px; height: 130px" :src="qrCodeImg" :preview-src-list="[qrCodeImg]"></el-image>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDownload" v-if="qrCodeImg">下载二维码</el-button>
        <!-- <el-button type="primary" @click="handleQrcode" v-else>生成二维码</el-button> -->
      </div>
      <div class="qrcode" ref="qrCodeUrl" id="qrcode" v-show="false"></div>
    </el-dialog>
       <!-- 变更发货订单弹窗 -->
       <el-dialog :visible.sync="changeDeliveryDialogVisible" width="600px" title="变更发货订单" :before-close="handleCloseChangeDelivery">
      <el-form v-loading="changeDeliveryLoading" ref="changeDeliveryForm" :model="changeDeliveryForm" label-width="120px" label-position="right">
        <el-form-item label="订单号：">
          <span>{{ changeDeliveryForm.orderNum }}</span>
        </el-form-item>
        <el-form-item label="下单人姓名：">
          <span>{{ changeDeliveryForm.custName }}</span>
        </el-form-item>
        <el-form-item label="下单人手机号：">
          <span>{{ changeDeliveryForm.custPho }}</span>
        </el-form-item>
        <el-form-item label="收货地址：" prop="addressId" :rules="[{ required: true, message: '请选择收货地址', trigger: 'change' }]">
          <el-select v-model="changeDeliveryForm.addressId" placeholder="请选择收货地址" clearable filterable style="width: 100%">
            <el-option
              v-for="address in addressList"
              :key="address.id"
              :label="`${address.province}${address.city}${address.district}${address.detailedAddress}`"
              :value="address.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleCloseChangeDelivery" size="mini">取消</el-button>
          <el-button type="primary" @click="handleSubmitChangeDelivery" size="mini">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { orderCancellationMessage } from '@/utils/order-cancellation-message'
import { orderStateTab } from '@/utils/virtual-order-navigation'
import Pagination from '@/components/Pagination'
import orderAdd from './add'
import { Subtr, accMul } from '@/utils/index'
import QRCode from 'qrcodejs2';
import changeFieldsVue from '@/views/common/changeFields.vue'
import seckillAddVue from './seckillAdd.vue'
import activitySummary from './activitySummary.vue'
export default {
  components: {
    Pagination,
    orderAdd,
    changeFieldsVue,
    seckillAddVue,
    activitySummary
  },
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNum: undefined,
        type: -1,
        orderSource: undefined,
        allGoodsName: undefined,
        orderPayType: undefined,
        name: undefined,
        phone: undefined,
        state: undefined,
        noFreight: undefined,
        deliveryOptionsId: undefined,
        logisticsNumber: undefined,
        parcelNum: undefined,
        customerIdcard: undefined,
        timeType: undefined,
        isLiveOrder: undefined,
        isLiveBlessingBag: undefined,
        isRechargeGift: undefined,
        // REQ-2026-826259 商城活动规则
        isActivityGoods: undefined,
        isCashOnlyGoods: undefined,
        activityPayMode: undefined,
      },
      dateTime: [],
      showMore: true,
      activeName: "2",
      listLoading: false,
      listRequestId: 0,
      list: [],
      total: 0,
      exchangeTotal: null,
      dialogVisible: false,
      dialogQuery: {
        deliveryOptionsId: undefined,
        orderNum: undefined,
      },
      orderNumError: false,
      dialogItem: "",
      dialogImgCode: false,
      deliveryList: [],
      deliveryAllList: [],
      multipleSelection: [],
      qrCodeImg: "",
      fullscreenLoading: false,
      allTemplate: [{ label: '订单编号', prop: 'orderNum' }, { label: '订单类型', prop: 'type' },
      { label: '商品名称', prop: 'allGoodsName', showToolTip: true, width: '160px' }, { label: '订单来源', prop: 'orderSource' }, { label: '订单标识', prop: 'orderFlag' },
      { label: '商品总件数', prop: 'allBuyNum' }, { label: '价格明细', prop: 'payTotalMoney', width: '200px' },
      { label: '应支付金额', prop: 'goodsPayMoney', width: '170px' }, { label: '支付方式', prop: 'orderPayType', width: '100px' },
      { label: '下单人信息', prop: 'custName', width: '170px' }, { label: '业务线', prop: 'business', width: '170px' }, { label: '技术线', prop: 'technical', width: '170px' },
      { label: '活动', prop: 'goodsActivityPOS' }, { label: '活动价', prop: 'killActPrice' },
      // REQ-2026-826259 商城活动规则
      { label: '活动支付模式', prop: 'activityPayModeName', width: '150px' },
      { label: '实际支付构成', prop: 'payCompositionText', width: '200px' },
      { label: '命中规则/活动标签', prop: 'activityTagList', width: '200px' },
      { label: '赠送结果', prop: 'rewardResultText', width: '200px' },
      { label: '快递方式', prop: 'deliveryOptionsName' },{ label: '收货信息', prop: 'name', width: '170px' }
        , { label: '随货同行单抬头', prop: 'customerIdcard' },  { label: '订单状态', prop: 'state' },
      { label: '下单时间', prop: 'createdTime', width: '160px' }, { label: '支付时间', prop: 'payTime', width: '160px' }
        , { label: '操作时间', prop: 'operatedTime', width: '160px' }, { label: '操作人', prop: 'operatedBy' }],
      dynamicHeaders: [],
      refundTypeTxt: ['', '余额', '零售价', '赠送', '积分'],
      // 变更发货订单相关
      changeDeliveryDialogVisible: false,
      changeDeliveryLoading: false,
      changeDeliveryForm: {
        orderId: null,
        orderNum: '',
        custName: '',
        custPho: '',
        addressId: null
      },
      addressList: []
    };
  },
  created() {
    let { type, name, cityId, startTime, endTime, orderNum } = this.$route.query;
    // 从「虚拟单自动流转」列表点订单号跳过来时带 orderNum，直接把搜索条件填上
    // （REQ-2026-826259）。订单详情是本页内的弹层不是独立路由，所以只能落到列表再点开。
    if (orderNum) this.applyOrderRoute(this.$route.query)
    if (type) this.query.type = +type
    if (name) this.query.name = name
    if (startTime && endTime) {
      this.dateTime = [startTime, endTime]
      this.query.timeType = 2
    }
    if (cityId) this.query.cityId = +cityId
    this.doQueryList({})
    this.getFieled();
  },
  watch: {
    '$route.query'(query, previous) {
      if (!query.orderNum || (query.orderNum === previous.orderNum && query.orderState === previous.orderState)) return
      this.applyOrderRoute(query)
      this.doQueryList({ pageNo: 1 })
    }
  },
  computed: {
    orderStatus() {
      return function (val) {
        switch (val) {
          case -1:
            return "已失效";
          case 0:
            return "已取消";
          case 1:
            return "待付款";
          case 2:
            return "待发货";
          case 3:
            return "待收货";
          case 4:
            return "已完成";
        }
      }

    }
  },
  methods: {
    applyOrderRoute(query) {
      this.query = { type: -1, orderNum: query.orderNum }
      this.dateTime = []
      this.multipleSelection = []
      this.activeName = orderStateTab(query.orderState) || '2'
    },
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    validateOrderNum(value) {
      if (!value) {
        this.orderNumError = false;
        return;
      }
      const pattern = /^[A-Za-z0-9]*$/;
      this.orderNumError = !pattern.test(value);
    },
    beforeDestroy() {
      // 清理可能的定时器或异步操作
      this.listLoading = false;
      this.fullscreenLoading = false;
    },
    changeOrderType() {
      let { type } = this.query
      if (type === -1) {
        this.deliveryAllList = []
        this.query.deliveryOptionsId = ''
        return
      }
      // 订货订单 1  秒杀订单 3
      let ty = type === 1 ? 1 : 2
      this.getAllDeliveryList(ty)
    },
    getAllDeliveryList(ty) {
      goodsOrderApi.getDeliveryList({ isEnable: true, orderType: ty }).then(res => {
        let { list } = res.data;
        this.deliveryAllList = list;
      })
    },
    getAfterTotalNum(requestId = this.listRequestId) {
      let params = JSON.parse(JSON.stringify(this.query));
      delete params.state
      delete params.pageNo
      delete params.pageSize
      delete params.receiptType
      return goodsOrderApi.getGoodsTotal(params).then((data) => {
        if (requestId !== this.listRequestId) return
        if (data.data) {
          this.exchangeTotal = data.data;
        } else {
          this.exchangeTotal = {
            deliverNum: 0, shippedNum: 0, accomplishNum: 0, unpaidNum: 0, cancelNum: 0
          }
        }
      })
    },
    getFieled() {
      if (localStorage.getItem('goodsOrderTableColumn')) {
        let tColumn = JSON.parse(localStorage.getItem('goodsOrderTableColumn'))
        this.dynamicHeaders = this.migrateActivityColumns(tColumn)
      } else {
        this.dynamicHeaders = this.allTemplate
      }
    },
    /**
     * REQ-2026-826259 一次性把新增的活动列补进用户已保存的列配置里。
     *
     * 列配置存在 localStorage，老用户那份里没有新列，不迁移的话新列永远不显示。
     * 用一个迁移标记只补一次，之后用户自己取消勾选的不再被强行加回来。
     */
    /** 订单标识；有赠送流水的订单加「活动订单」（BUG-2026-653617，act_id 不可靠，按流水判） */
    orderFlagText(row) {
      const flags = []
      if (row.liveId) flags.push('直播订单')
      else if (row.liveBlessingBagId) flags.push('直播福袋订单')
      else if (row.rechargeGiftRecordId > 0) flags.push('充值礼包订单')
      if (Array.isArray(row.activityRewardLogList) && row.activityRewardLogList.length) flags.push('活动订单')
      return flags.length ? flags.join('、') : '-'
    },
    migrateActivityColumns(tColumn) {
      const MIGRATED_KEY = 'goodsOrderTableColumn_activityRuleMigrated'
      if (localStorage.getItem(MIGRATED_KEY)) return tColumn
      const newProps = ['activityPayModeName', 'payCompositionText', 'activityTagList', 'rewardResultText']
      const merged = tColumn.slice()
      newProps.forEach(prop => {
        if (merged.some(it => it.prop === prop)) return
        const define = this.allTemplate.find(it => it.prop === prop)
        if (!define) return
        // 插到「快递方式」前，跟 allTemplate 里的位置保持一致
        const anchorIdx = merged.findIndex(it => it.prop === 'deliveryOptionsName')
        if (anchorIdx > -1) merged.splice(anchorIdx, 0, define)
        else merged.push(define)
      })
      localStorage.setItem(MIGRATED_KEY, '1')
      localStorage.setItem('goodsOrderTableColumn', JSON.stringify(merged))
      return merged
    },
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return
      let allList = JSON.parse(JSON.stringify(this.allTemplate))
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1)
      this.dynamicHeaders = newL;
      console.log(newL)
      localStorage.setItem('goodsOrderTableColumn', JSON.stringify(newL))
    },
    calcQuery() {
      let { timeType } = this.query
      if (timeType && this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0]
        this.query.endTime = this.dateTime[1]
      } else {
        this.query.startTime = undefined
        this.query.endTime = undefined
      }
    },
    doQueryList({ pageNo, pageSize }) {
      const requestId = ++this.listRequestId
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      console.log(this.query)
      this.query.state = +this.activeName
      //当选择了6，自提要单独写参数
      if(this.activeName === '6') {
        this.query.receiptType = 20
        this.query.state=3
      } else{
      delete this.query.receiptType 

      }
      this.listLoading = true
      this.getAfterTotalNum(requestId)
      return goodsOrderApi.getGoodsOrder(this.query).then(res => {
        if (requestId !== this.listRequestId) return
        let { list, total } = res.data;
        if (list.length) {
          list.forEach(it => {
            it.allPay = Subtr(it.allPayMoney, -it.rmbMoney)
          })
        }
        this.list = list;
        this.total = total;
      }).catch(err => {
        if (requestId !== this.listRequestId) return
        // BUG-2026-982709：接口挂了不能把上一个页签的数据继续摆在这儿。
        // 当时的表现是「已完成」页签 500，表格却还显示着「待发货」的单子、
        // 也没有任何提示——用户会当成那就是已完成订单，比直接报错危险得多。
        // 请求失败一律清空并明确提示。
        this.list = []
        this.total = 0
        this.$message.error('订单列表加载失败，请稍后重试')
        console.error('订单列表查询失败:', err)
      }).finally(() => {
        if (requestId === this.listRequestId) this.listLoading = false
      })
    },
    handleFilter() {
      this.query = { type: -1 };
      this.dateTime = [];
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 点击搜索
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    // 切换订单类型
    handleClick(e) {
      // 使用 nextTick 确保DOM更新完成后再进行列操作
      this.$nextTick(() => {
        // 检查是否点击了"已取消"标签
        if (e.name === "0") {
          // 检查是否已经存在退款明细列
          const hasRefundDetail = this.dynamicHeaders.some(item => item.prop === 'refundDetail');
          if (!hasRefundDetail) {
            // 找到应支付金额列的位置
            const goodsPayMoneyIndex = this.dynamicHeaders.findIndex(item => item.prop === 'goodsPayMoney');
            if (goodsPayMoneyIndex !== -1) {
              // 创建新的数组来避免直接修改原数组
              const newHeaders = [...this.dynamicHeaders];
              newHeaders.splice(goodsPayMoneyIndex + 1, 0, {
                label: '退款明细',
                prop: 'refundDetail',
                width: '160px'
              });
              this.dynamicHeaders = newHeaders;
            }
          }
        } else {
          // 如果不是"已取消"标签，移除退款明细列
          this.dynamicHeaders = this.dynamicHeaders.filter(item => item.prop !== 'refundDetail');
        }
      });

      this.doQueryList({ pageNo: 1 })
    },
    // 导出
    // handleDownload() {
    //   return this.$common.confirm('是否确认导出')
    //     .then(() => goodsOrderApi.exportExcelGoods(this.query, 1))
    // },
    handleExport() {
      this.$router.push("/export/list?code=ExportCustomerOrder,ExportCustomerOrderGoods&orderType=1")
    },
    changeShow() {
      this.showMore = !this.showMore;
    },
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleShow(row) {
      row.activeName = +this.activeName
      this.$emit('handleShow', row, 2)
    },
    // 1、复制订单   2、添加运单号   3、补推订单  4、取消订单  5、订单二维码  6、支付  7、取消订单(聚水潭)  8、支付秒杀订单  9、核销订单
    handleUpOrder(row, type) {
      switch (type) {
        case 1:
          this.strtCopy(row);
          break;
        case 2:
          this.openDialog(row);
          break;
        case 3:
          this.tuiOrder(row);
          break;
        case 4:
          this.cancelOrder(row);
          break;
        case 5:
          this.getQrCode(row)
          break;
        case 6:
          this.payOrder(row)
          break;
        case 7:
          this.cancelOrder(row, 1)
          break;
        case 8:
          this.paySeckillOrder(row)
          break;
        case 9:
          this.writeoffOrder(row)
          break;
        case 10:
          this.openChangeDeliveryDialog(row)
          break;
      }
    },
    //获取二维码
    getQrCode(row) {
      goodsOrderApi.QRcode(row.id).then(res => {
        this.qrCodeImg = 'data:image/jpeg;base64,' + res.data
        this.dialogImgCode = true;
      })

    },
    //支付订单
    payOrder(row) {
      this.$common.confirm('是否确认支付该订单？', '', {
        confirmButtonText: '确定支付',
      }).then(() => goodsOrderApi.bgPay({ orderId: row.id }))
        .then((res) => {
          if (res.code === '0') {
            this.$alert('支付成功，请提示客户先前往前往app查看订单！', '', {
              confirmButtonText: '知道了',
              callback: action => {
                this.doQueryList({});
              }
            });
          }
        })
    },
    // 支付秒杀订单
    paySeckillOrder(row) {
      this.$common.confirm('是否确认支付该秒杀订单？', '', {
        confirmButtonText: '确定支付',
      }).then(() => goodsOrderApi.bgPaySeckill({ orderId: row.id }))
        .then((res) => {
          if (res.code === '0') {
            this.$alert('支付成功，请提示客户前往app查看订单！', '', {
              confirmButtonText: '知道了',
              callback: action => {
                this.doQueryList({});
              }
            });
          }
        })
    },
    // 核销订单（单个）
    writeoffOrder(row) {
      this.$common.confirm('是否确认核销该订单？', '', {
        confirmButtonText: '确定核销',
      }).then(() => {
        goodsOrderApi.writeoffBatch([row.id.toString()]).then((res) => {
          if (res.code === '0') {
            this.$message.success('核销成功');
            this.doQueryList({});
          } else {
            this.$message.error(res.msg || '核销失败');
          }
        }).catch(err => {
          this.$message.error('核销失败');
          console.error(err);
        });
      }).catch(() => {});
    },
    // 复制订单
    strtCopy(row) {
      this.$refs.orderAdd.handleCreate(row)
      // console.log(row)
      // var msg = "商品:" + row.allGoodsName + ",订单编号:" + row.orderNum + ",订单来源:" + row.orderSource + ",商品支付金额:¥" + row.goodsPayMoney + ",邮费支付金额:¥" + row.freight + ",支付总金额:¥" + row.allPay + ",数量:" + row.allBuyNum;
      // const input = document.createElement('input');
      // document.body.appendChild(input);
      // input.setAttribute('value', msg); //msg:是我们需要复制的文字内容
      // input.select();
      // try {
      //   let result = document.execCommand("copy");
      //   document.body.removeChild(input);
      //   if (!result) {
      //     this.$message.warning("复制失败");
      //   } else {
      //     this.$message.success("复制成功");
      //   }
      // } catch (e) {
      //   document.body.removeChild(input);
      //   this.$message.warning("当前浏览器不支持复制功能");
      // }
    },
    // 添加运单号
    openDialog(row) {
      goodsOrderApi.getDeliveryList({ isEnable: true, orderType: row.type === 1 ? 1 : 2 }).then(res => {
        let { list } = res.data;
        this.deliveryList = list;
        this.dialogVisible = true;
        this.dialogItem = row;
      })
    },
    closeDialog() {
      this.dialogVisible = false;
      this.deliveryList = [];
      this.dialogItem = "";
      this.fullscreenLoading = false;
      this.dialogQuery.deliveryOptionsId = undefined;
      this.dialogQuery.orderNum = undefined;
    },
    addLogisticsNumber() {
      let { deliveryOptionsId, orderNum } = this.dialogQuery
      if (this.fullscreenLoading) return;
      if (deliveryOptionsId == undefined) return this.$message({ message: '请选择快递公司!' });
      if (orderNum == undefined) return this.$message({ message: '请填写运单号!' });
      let find = this.deliveryList.find(item => item.id === deliveryOptionsId)
      let obj = {
        orderId: this.dialogItem.id,
        deliveryCode: find.code,
        deliveryName: find.name,
        deliveryNum: orderNum,
        type: 2
      }
      this.fullscreenLoading = true;
      goodsOrderApi.addGoodsLogisticsNumber(obj).then(res => {
        this.$message({ type: 'success', message: '添加成功!' });
        this.closeDialog();
        this.doQueryList({ pageNo: 1 });
      })
    },
    // 补推订单
    tuiOrder(row) {
      this.$confirm('确定将本订单再一次推送到聚水潭平台中?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.goodsTuiOrder(row.id.toString());
      }).catch(() => { });
    },
    goodsTuiOrder(id) {
      goodsOrderApi.goodsTuiOrder({ orderid: id }).then(res => {
        this.$message({
          type: 'success',
          message: '推送成功!'
        });
      })
    },
    // 取消订单
    cancelOrder(row, type) {
      // 根据type参数设置不同的提示信息
      const promptMessage = type === 1 ? '请输入取消原因(<span style="color: red; font-weight: bold;">取消聚水潭订单</span>)' : '请输入取消原因(<span style="color: red; font-weight: bold;">只取消APP订单</span>)'
      
      this.$prompt(promptMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        inputPattern: /./,
        inputErrorMessage: '请输入取消原因',
        dangerouslyUseHTMLString: true
      }).then(value => {
        let params = { orderId: row.id, refundReason: value.value }
        if (+this.activeName === 1) {
          goodsOrderApi.cancelGoodsOrder(params).then(res => {
            this.$message(orderCancellationMessage(res));
            this.doQueryList({});
          })
        } else {
          params.type = type ? 1 : 0
          goodsOrderApi.cancelOrder(params).then(res => {
            this.$message(orderCancellationMessage(res));
            this.doQueryList({});
          })
        }

      })
    },
    // 添加订货订单
    handleAdd() {
      this.$refs.orderAdd.handleCreate()
    },
    handleSeckillAdd() {
      this.$refs.seckillAdd.handleCreate()
    },
    selectionChange(val) { this.multipleSelection = val; },
    // 补推订单
    addOrderToYongYou() {
      console.log(this.multipleSelection)
      if (!this.multipleSelection.length) return this.$message({ message: '请选择补推订单!' });
      let id = [];
      this.multipleSelection.forEach(it => {
        id.push(it.id)
      })
      id = id.join(',');
      this.$confirm('确定将本订单再一次推送到聚水潭平台中?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.goodsTuiOrder(id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消补推订单'
        });
      });
    },
    handleQRCode() {
      this.dialogImgCode = true;

    },
    handleQrcode() {
      // let qrcode = new QRCode(this.$refs.qrCodeUrl, {
      //   text: `http://www.baidu.com`, // 需要转换为二维码的内容
      //   width: 200,
      //   height: 200,
      //   colorDark: "#000000",
      //   colorLight: "#ffffff",
      //   correctLevel: QRCode.CorrectLevel.H,
      // });
      // let myCanvas = document.getElementById("qrcode").getElementsByTagName("canvas");
      // let url = myCanvas[0].toDataURL("image/png");
      // this.qrCodeImg = url

    },
    handleDownload() {
      let { qrCodeImg } = this;
      if (!qrCodeImg) return
      let a = document.createElement("a");
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.href = this.qrCodeImg;
      a.download = "订单二维码.png"; // 图片名称
      a.dispatchEvent(event); // 触发a的单击事件
      this.$message({ message: "下载成功", type: "success" });
    },
    // 表格排序变化处理
    sortChange({ column, prop, order }) {
      console.log('排序变化:', { column, prop, order });
      // 这里可以添加排序逻辑
      if (order) {
        this.query.sortField = prop;
        this.query.sortOrder = order === 'ascending' ? 'asc' : 'desc';
      } else {
        this.query.sortField = '';
        this.query.sortOrder = '';
      }
      this.doQueryList({});
    },
    // 对话框关闭处理
    handleClose(done) {
      if (done) {
        done();
      } else {
        this.dialogVisible = false;
        this.dialogImgCode = false;
      }
    },
    // 批量核销订单
    handleBatchWriteoff() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请选择要核销的订单');
        return;
      }
      // 筛选出符合条件的订单（自提订单：receiptType === 20）
      const validOrders = this.multipleSelection.filter(order => order.receiptType === 20);
      if (validOrders.length === 0) {
        this.$message.warning('所选订单中没有可核销的自提订单');
        return;
      }
      if (validOrders.length < this.multipleSelection.length) {
        this.$message.warning(`已筛选出 ${validOrders.length} 个可核销的自提订单，将核销这些订单`);
      }
      // 将订单id转为字符串数组格式
      const orderIds = validOrders.map(order => order.id.toString());
     
      this.$common.confirm(`确定要批量核销 ${validOrders.length} 个订单吗？`, '', {
        confirmButtonText: '确定核销',
      }).then(() => {
        // 传递订单id数组
        goodsOrderApi.writeoffBatch(orderIds).then((res) => {
          if (res.code === '0') {
            this.$message.success('批量核销成功');
            this.doQueryList({});
            // 清空选择
            this.multipleSelection = [];
            // 清空表格选择
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection();
              }
            });
          } else {
            this.$message.error(res.msg || '批量核销失败');
          }
        }).catch(err => {
          this.$message.error('批量核销失败');
          console.error(err);
        });
      }).catch(() => {});
    },
     // 批量变更发货订单
     handlechangeReceiptMailingBatch() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning('请选择要核销变更发货的自提订单');
        return;
      }
      // 筛选出符合条件的订单（自提订单：receiptType === 20）
      const validOrders = this.multipleSelection.filter(order => order.receiptType === 20);
      if (validOrders.length === 0) {
        this.$message.warning('所选订单中没有可核销的自提订单');
        return;
      }
      if (validOrders.length < this.multipleSelection.length) {
        this.$message.warning(`已筛选出 ${validOrders.length} 个可变更发货的自提订单，将变更发货这些订单`);
      }
      // 将订单转为对象数组格式，包含 addressId 和 id
      const orderIds = validOrders.map(order => ({
        addressId: null,
        id: order.id
      }));
     
      this.$common.confirm(`确定要批量变更发货 ${validOrders.length} 个订单吗？`, '', {
        confirmButtonText: '确定核销',
      }).then(() => {
        // 传递订单对象数组
        goodsOrderApi.changeReceiptMailingBatch(orderIds).then((res) => {
          if (res.code === '0') {
            this.$message.success('批量变更发货成功');
            this.doQueryList({});
            // 清空选择
            this.multipleSelection = [];
            // 清空表格选择
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection();
              }
            });
          } else {
            this.$message.error(res.msg || '批量变更发货失败');
          }
        }).catch(err => {
          this.$message.error('批量变更发货失败');
          console.error(err);
        });
      }).catch(() => {});
    },
    // 打开变更发货订单对话框
    openChangeDeliveryDialog(row) {
      this.changeDeliveryForm = {
        orderId: row.id,
        orderNum: row.orderNum || '',
        custName: row.custName || '',
        custPho: row.custPho || '',
        addressId: null
      };
      // 获取客户地址列表
      if (row.userId) {
        this.changeDeliveryLoading = true;
        goodsOrderApi.getUserAddrList({ userId: row.userId }).then(res => {
          if (res.data && res.data.list) {
            this.addressList = res.data.list;
          } else {
            this.addressList = [];
          }
        }).catch(err => {
          console.error('获取地址列表失败:', err);
          this.addressList = [];
        }).finally(() => {
          this.changeDeliveryLoading = false;
        });
      } else {
        this.$message.warning('订单缺少用户ID，无法获取地址列表');
        this.addressList = [];
      }
      this.changeDeliveryDialogVisible = true;
    },
    // 关闭变更发货订单对话框
    handleCloseChangeDelivery(done) {
      if (done) {
        done();
      } else {
        this.changeDeliveryDialogVisible = false;
      }
      // 重置表单
      this.changeDeliveryForm = {
        orderId: null,
        orderNum: '',
        custName: '',
        custPho: '',
        addressId: null
      };
      this.addressList = [];
      this.changeDeliveryLoading = false;
    },
    // 提交变更发货订单
    handleSubmitChangeDelivery() {
      if (!this.changeDeliveryForm.addressId) {
        this.$message.warning('请选择收货地址');
        return;
      }
      // 从当前订单数据中获取订单ID
      const currentOrder = this.list.find(order => order.orderNum === this.changeDeliveryForm.orderNum);
      if (!currentOrder) {
        this.$message.error('未找到订单信息');
        return;
      }
      this.changeDeliveryLoading = true;
      const params = [{
        addressId: this.changeDeliveryForm.addressId,
        id: currentOrder.id
      }];
      goodsOrderApi.changeReceiptMailingBatch(params).then((res) => {
        if (res.code === '0') {
          this.$message.success('变更发货成功');
          this.handleCloseChangeDelivery();
          this.doQueryList({});
        } else {
          this.$message.error(res.msg || '变更发货失败');
        }
      }).catch(err => {
        this.$message.error('变更发货失败');
        console.error(err);
      }).finally(() => {
        this.changeDeliveryLoading = false;
      });
    },
  },
};
</script>
<style>
.block {
  padding: 20px 0;
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.tableDiv-txt {
  display: flex;
  flex-direction: column;
}
/* REQ-2026-826259 活动相关列的辅助文案 */
.cash-only-txt {
  color: #e6a23c;
}
.rule-id-txt {
  color: #909399;
  font-size: 12px;
}
.dialogDiv .el-select {
  display: block !important;
}
.image {
  width: 100%;
  display: block;
}
.codeDiv {
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.el-dialog__footer {
  text-align: center;
}
.img-box {
  text-align: center;
}
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
